<template>
  <v-app  v-bind:style="stylePagina">
    <v-main  v-bind:style="stylePagina">
      <v-container-fluid>

        <header id="main-cabecera"   style="height: 60px; width: 100%; left:0; top:0; position: fixed">
          <v-row align="center" v-bind:style="styleCabecera" class="text-center">
            <v-col cols="6" sm="6" md="6" lg="6" style="text-align: right;">
              <h1 v-if="logoexist" class="display-1 font-weight-bold">
                <v-img style="height: 50px;" contain :src="logoimg" />
              </h1>
              <h1 v-else>{{titulonegocio}}</h1>
            </v-col>
            <v-col cols="6" sm="6" md="6" lg="6">
              <v-img style="height: 50px;" contain src="@/assets/logo_perumin.png" />

            </v-col>
          </v-row>
        </header>

        <section id="main-cuerpo" v-bind:style="stylePagina">
          <v-row justify="center"   v-bind:style="styleMain" align="center"><v-col cols="9"  style="text-align: justify; color:#858389 !important; text-align: center; word-break: normal ;font-size: 20pt; font-weight: bolder; padding-top:50px;" ><p> Catálogos </p>
          </v-col></v-row>
          <v-row  justify="center" v-bind:style="styleMain" align="center">
            <v-col  cols="10" sm="10" md="8" lg="8">
              <v-card class="ma-6" v-bind:style="styleForm" elevation="10">

                <v-card-text>
    <v-row justify="center" align="center">
      <v-col cols="6">
        <v-row>
          <v-col><v-img @click="goto(1)" width="100%" src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png" /></v-col>
        </v-row>
        <v-row>
          <v-col><p @click="goto(1)">Guia de Usuario Brio</p></v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col><v-img @click="goto(2)" width="100%" src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png" /></v-col>
        </v-row>
        <v-row>
          <v-col><p @click="goto(2)">Catalogo Brio</p></v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col><v-img @click="goto(3)" width="100%" src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png" /></v-col>
        </v-row>
        <v-row>
          <v-col><p @click="goto(3)">Book Industrial</p></v-col>
        </v-row>
      </v-col><v-col cols="6">
      <v-row>
        <v-col><v-img @click="goto(4)" width="100%" src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png" /></v-col>
      </v-row>
      <v-row>
        <v-col><p @click="goto(4)">Construction Book</p></v-col>
      </v-row>
    </v-col>
    </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

        </section>
      </v-container-fluid>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
export default {
  name: "formulariodatos",
  data () {
    return {
      tagevento:'',
      alertnuevo: false,
      menu1: false,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      paises:[],
      rest: false,
      labelNombre:'Nombre',
      labelEmail:'Email',
      titulonegocio:'',
      logoexist: false,
      logoimg : '',
      eventodisenio: {},
      stylePagina: {
        fontColor:'black',
        fontFamily: 'Calibri',
        color: '#000000',
        paddingTop:'60px'
      },
      styleComponent:{
        color:'#000000',
      },
      styleCabecera:{
        color:'#000000',
        backgroundColor:'#ffffff'
      },
ciudadId:0,
      ciudades:[],
      provinciaId:0,
      provincias:[],
      docurl:'',
      paisId:0,
      catalogoUno:"https://tunaydocs.s3.amazonaws.com/GU_BRIO_05H028ESM-ULMA-Construction.pdf",
      catalogoDos:"https://tunaydocs.s3.amazonaws.com/CAT_BRIO_ES.pdf",
        catalogoTres:"https://tunaydocs.s3.amazonaws.com/BOOK_INDUSTRIAL+PERU_ES.pdf",
        catalogoCuatro:"https://tunaydocs.s3.amazonaws.com/Construction+Book+_+ULMA.pdf",

      styleForm:{
        color:'#000000',
        backgroundColor:'#ffffff'
      },
      styleMain:{

      },
      btnPag: {
        backgroundColor: 'blue',
        color:'white'
      },
      tag:'',
      catalogoId:0,
      docbaja:'',
      referido:'',
      editedItem:{
        nombre:'',
        celular:'',


      }
    }
  },
  created () {
    this.$vuetify.theme.dark = false
  },

  mounted () {
    this.tagevento =  this.$route.params.tagevento;
    this.catalogoId = this.$route.params.number;
    this.damedisenio();
  },
  methods: {
    save(){
      var bodyFormData = new FormData();
        bodyFormData.append("data",JSON.stringify(this.editedItem))
       this.rest = true
      axios
          .post('general/formulario/datos',bodyFormData)
          .then(response => {
            let ticketMin = response.data;
            console.log(ticketMin)
            this.alertnuevo = true
            this.rest = false
            console.log(this.catalogoId)
            switch (this.catalogoId){
              case "1":
                this.docbaja = this.catalogoUno
                    break;
              case "2":
                this.docbaja = this.catalogoDos
                    break;
              case "3":
                this.docbaja = this.catalogoTres
                    break;
              case "4":
                this.docbaja = this.catalogoCuatro
                    break;
              default:
                  this.docbaja='sin'
                    break;
            }
            window.location.href = this.docbaja
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    goto(item){
      this.$router.push({'name':'catalogoformulario', params:{tagevento:'ulma',number:item}})
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    },
    damedisenio(){
      axios
          .get('disenio/evento/'+this.tagevento)
          .then(response => {
            this.eventodisenio = response.data;
            this.logoexist = this.eventodisenio.logoCargado;
            this.logoimg = this.eventodisenio.logo;
            this.stylePagina.backgroundColor = this.eventodisenio.backgroundColor;
            this.stylePagina.color = this.eventodisenio.colorText;
            this.btnPag.color = this.eventodisenio.colorTextBotn;
            this.btnPag.backgroundColor = this.eventodisenio.colorBgBoton;
            this.labelRef1 = this.eventodisenio.labelRef1;
            this.labelRef2 = this.eventodisenio.labelRef2;
            this.camporef1 = this.eventodisenio.camporef1;
            this.camporef2 = this.eventodisenio.camporef2;
            this.stylePagina.backgroundImage = "url('"+this.eventodisenio.backgroundImage+"')";
            this.styleMain.backgroundSize = "cover";
            this.styleCabecera.backgroundColor = this.eventodisenio.backCabeceraColor;
          })
          .catch((error)  => {
            console.log(error);
          });
    }
  }
}
</script>

<style scoped>

</style>